import moment from "moment";
import React from "react";
import {
	TORB3BackendRecord,
	TORB3Record,
} from "../../../../../redux/app/orb3/@types";
import { TORB3GroupF1 } from "../../../../../redux/app/orb3/groups/group-f";
import ORB3TableRows from "../ORB3TableRows";

type OwnProps = {
	orb3Record: TORB3Record | TORB3BackendRecord;
	theme?: "light" | "dark";
};
type ORB3GroupF1PreviewProps = OwnProps;

function ORB3GroupF1Preview(props: ORB3GroupF1PreviewProps) {
	const record = props.orb3Record as TORB3GroupF1;
	const operationDate = moment(record.selectedDate, "YYYY-MM-DD").format(
		"DD-MMM-YYYY",
	);

	function renderMain() {
		return (
			<ORB3TableRows
				record={record}
				tableRows={[[operationDate, "3-F", "NOTE", record.remarks]]}
				theme={props.theme}
			/>
		);
	}

	return renderMain();
}

export default ORB3GroupF1Preview;
